module.exports = __webpack_public_path__ + "img/report_book.c6faec45.svg";